import { typesSupportOccorence } from "../constants";
import { IOccurrence } from "../types";
import Chip from "./Chip";
import moment from "moment";

interface Props {
    onClick: () => void;
    data: IOccurrence;
    disabled?: boolean;
}

export const convertMinutesToHours = (minutes?: number) => {
    if (!minutes) {
        return '-'
    };

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours === 0) {
        return `${mins} min`;
    }

    if (mins === 0) {
        return `${hours} h`;
    }

    return `${hours}h ${mins}min`;
};

const BoardItem = ({ onClick, data, disabled }: Props) => {
    return (
        <div className={`bg-white flex-1-1 border rounded rounded-small padding-10 ${disabled ? '': 'cursor-pointer'}`} style={{ borderColor: '#344054', height: 184 }} onClick={() => disabled ?  null: onClick()}>
            <div className="border border-bottom-only display-flex justify-content-between padding-bottom-4">
                <span className="text-medium text-size-14">{data?.tasOccurrenceNumber}</span>
                <span>{convertMinutesToHours(data?.timeInStatus)} nessa etapa</span>
            </div>
            <div className="display-flex flex-column margin-top-4 gap-4">
                <div className="display-flex justify-content-between">
                    <span className="text-size-14 line-height-20">{data?.licensePlate}</span>
                    <span className="text-size-14 line-height-20">{data?.customer}</span>
                </div>
                <div className="display-flex justify-content-between">
                    <span className="text-size-14 line-height-20">Proprietário:</span>
                    <span className="text-size-14 line-height-20">{data?.responsible}</span>
                </div>
                <div className="display-flex justify-content-between align-items-center">
                    <div className="display-flex flex-column gap-4 padding-left-4">
                        <span className="text-size-14 line-height-20">{typesSupportOccorence[data?.supportType?.toUpperCase() as keyof typeof typesSupportOccorence] || '-'}</span>
                        {/* <span className="text-size-14 line-height-20">5.Contrato bloqueado</span> */}
                    </div>
                    <div>
                        <Chip type={data?.subject} />
                    </div>
                </div>
                <div className="display-flex justify-content-between">
                    <span className="text-size-14 line-height-20">-</span>
                    <span className="text-size-14 line-height-20">{moment(data?.updatedAt).format('DD/MM/YYYY HH:mm')}</span>
                </div>
                {/* <div className="display-flex gap-5">
                    <span className="text-size-20 rioglyph rioglyph-chat cursor-pointer" style={{ color: '#B5B5B5' }}></span>
                    <span className="text-size-20 rioglyph rioglyph rioglyph-paper-clip cursor-pointer" style={{ color: '#B5B5B5' }}></span>
                </div> */}
            </div>
        </div>
    )
};

export default BoardItem;